"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const core_1 = require("@material-ui/core");
const profileSlice_1 = require("../../redux/slices/profileSlice");
const userSlice_1 = require("../../redux/slices/userSlice");
const staticDataSlice_1 = require("../../redux/slices/staticDataSlice");
const edit_1 = __importDefault(require("./components/edit/edit"));
const view_1 = __importDefault(require("./components/view/view"));
require("./styles.scss");
const EditIcon_1 = __importDefault(require("../../svgIcons/EditIcon"));
class App extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.toggleEdit = () => {
            const { user, profile: { editProfile } } = this.props;
            this.props.toggleProfileEdit({ payload: user });
            if (editProfile) {
                this.props.resetState();
            }
        };
    }
    componentDidMount() {
        const { options: { type, userId, firstFlow } } = this.props;
        if (userId) {
            this.props.getUserAllData(userId, type === 'guest', true);
        }
        if (firstFlow) {
            this.props.setFirstFlow({ firstFlow });
        }
        this.props.getStates();
        localStorage.removeItem('profile_changed');
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const { user, profile: { editProfile, firstFlow } } = this.props;
        if (firstFlow && !editProfile && user.name) {
            this.props.toggleProfileEdit({ payload: user });
        }
    }
    render() {
        var _a;
        const { profile: { editProfile, firstFlow }, options: { type }, user } = this.props;
        const guest = type === 'guest';
        const waiting = (_a = user === null || user === void 0 ? void 0 : user.states) === null || _a === void 0 ? void 0 : _a.every((i) => !(i === null || i === void 0 ? void 0 : i.bar_number_status));
        return (react_1.default.createElement(react_1.Fragment, null,
            !firstFlow && react_1.default.createElement("div", { className: `tab-titles ${guest || editProfile ? 'mb-30' : ''}` },
                "Profile",
                guest && user.deleted && react_1.default.createElement("span", { className: 'pt-10' }, "This account has been deleted."),
                guest && waiting && user.roleId !== 9 && !user.deleted && react_1.default.createElement("span", { className: 'pb-10 pt-10' }, "This account is Waiting Approval.")),
            react_1.default.createElement(core_1.Box, { className: 'v2-main-container', style: { margin: '0 auto' } },
                !guest && !editProfile && react_1.default.createElement("div", { className: 'text-right mr-10 mb-10' },
                    react_1.default.createElement(core_1.Button, { onClick: this.toggleEdit, "data-qa": 'edit-profile', variant: "text", disableRipple: true, startIcon: react_1.default.createElement(EditIcon_1.default, null), className: "v2-btn-icon-link" }, "Edit Profile")),
                editProfile ? react_1.default.createElement(edit_1.default, { className: `${guest && user.deleted ? 'deleted-view' : ''}` }) : react_1.default.createElement(view_1.default, { guest: guest, className: `${guest && user.deleted ? 'deleted-view' : ''}` }))));
    }
}
const mapStateToProps = (state) => {
    const { profile, user } = state;
    return {
        profile,
        user
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        toggleProfileEdit: (data) => dispatch(profileSlice_1.toggleProfileEdit(data)),
        resetState: () => dispatch(profileSlice_1.resetState()),
        resetUser: () => dispatch(userSlice_1.resetUser()),
        getStates: () => dispatch(staticDataSlice_1.getStates()),
        setFirstFlow: (data) => dispatch(profileSlice_1.setFirstFlow(data)),
        getUserAllData: (id, guest, loader) => dispatch(userSlice_1.getUserAllData(id, guest, loader)),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(App);
